import BpkCardList from '@skyscanner-internal/backpack-web/bpk-component-card-list';
import {
  ACCESSORY_DESKTOP_TYPES,
  LAYOUTS,
} from '@skyscanner-internal/backpack-web/bpk-component-card-list/src/common-types';
import classNames from 'classnames';

import { useMBDContext } from '../common/MBD/useMBDContext';

import InfoSnippetPanel from './InfoSnippetPanel';

import type { BestTimeToVisitMonthPickerProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/BestTimeToVisitMonthPickerProps';

import STYLES from './BestTimeToVisitMonthPicker.module.scss';

const BestTimeToVisitMonthPicker = (props: BestTimeToVisitMonthPickerProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();

  if (!props.panelValues || props.panelValues.length === 0) {
    return null;
  }
  const {
    ctaText,
    hideBottomSnippets,
    hideCtaButton,
    isCompactCard,
    panelLabels,
    panelValues,
    subtitle,
    title,
  } = props;

  const containerClassName = classNames(STYLES.BestTimeToVisitMonthPicker, {
    [STYLES['BestTimeToVisitMonthPicker--default']]: isCompactCard === false,
    [STYLES['BestTimeToVisitMonthPicker--compact']]: isCompactCard,
  });

  return (
    <div
      className={containerClassName}
      data-testid="bestTimeToVisitMonthPicker"
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      <BpkCardList
        initiallyShownCardsDesktop={2}
        initiallyShownCardsMobile={12}
        title={title}
        description={subtitle}
        cardList={panelValues.map((panelValue, index) => (
          <InfoSnippetPanel
            key={panelValue.monthName}
            panelLabels={panelLabels}
            panelValue={panelValue}
            ctaText={ctaText}
            panelIndex={index}
            isCompactCard={isCompactCard}
            hideBottomSnippets={hideBottomSnippets}
            hideCtaButton={hideCtaButton}
          />
        ))}
        layoutDesktop={LAYOUTS.row}
        layoutMobile={LAYOUTS.rail}
        accessoryDesktop={ACCESSORY_DESKTOP_TYPES.pagination}
      />
    </div>
  );
};

export default BestTimeToVisitMonthPicker;
